//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      divLeft: 0,
      parentTop: 0,
      // 父级距离顶部的高度
      divTop: 0,
      //内部距离顶部的高度
      multiples: 1,
      valueList: [],
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      width1: 0,
      height1: 0
    };
  },
  props: {
    srcUrl: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: true
    },
    axis: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    axis: {
      handler: function handler(newValue, oldValue) {
        for (var i in this.axis) {
          this.addAttress(this.axis[i]);
        }
      },
      deep: true
    },
    srcUrl: function srcUrl(newValue, oldValue) {
      var _this = this;

      var img = new Image(); // 改变图片的src

      img.src = newValue; // 加载完成执行

      img.onload = function () {
        // 打印
        _this.height = img.height;
        _this.height1 = img.height;
        _this.width = img.width;
        _this.width1 = img.width;

        if (_this.valueList && _this.valueList.length > 0 && _this.valueList[0].x) {
          _this.x = _this.valueList[0].x;
          _this.y = _this.valueList[0].y;
        }

        console.log('width:' + img.width + ',height:' + img.height);
        var devObj = _this.$refs.imageContent;
        var cHeight = devObj.clientWidth * img.height / img.width;

        _this.$emit('userWidthHeight', devObj.clientWidth, cHeight);
      };
    },

    /**
     * 缩放改变时
     */
    multiples: function multiples(newValue, oldValue) {
      if (this.width > 0) {
        this.height1 = this.height * newValue;
        this.width1 = this.width * newValue;

        for (var i in this.valueList) {
          this.$set(this.valueList[i], 'x', this.x * this.height1 / this.height);
          this.$set(this.valueList[i], 'y', this.y * this.width1 / this.width);
        }

        console.log(this.valueList);
      }
    }
  },
  methods: {
    /**
     * 监听图片的滚动条滚动，并计算距离顶部的调试
     */
    scrool: function scrool(event) {
      var targetObje = event.target;
      var top = targetObje.scrollTop;

      if (targetObje.className.indexOf('imgContent') > -1 || targetObje.className.indexOf('imageContent') > -1) {
        this.divTop = top;
        this.divLeft = targetObje.scrollLeft;
        console.log(this.divTop);
        console.log(this.divLeft);
      } else {
        this.parentTop = top; // console.log("父级高度："+this.parentTop)
      }
    },
    changeImageWh: function changeImageWh() {},

    /**
     * 还原
     */
    reset: function reset() {
      this.multiples = 1;
    },

    /**
     * 放大
     */
    bigChange: function bigChange() {
      if (this.multiples >= 4) {
        return false;
      }

      this.multiples += 0.25;
    },

    /**
     * 缩小
     */
    smallChange: function smallChange() {
      if (this.multiples <= 1) {
        return false;
      }

      this.multiples -= 0.25;
    },
    dropImage: function dropImage(e) {},

    /**
     * 鼠标滑轮滚动
     */
    gunlun: function gunlun(e) {
      var direction = e.deltaY > 0 ? 'down' : 'up';

      if (direction === 'up') {
        // 滑轮向上滚动
        this.bigChange();
      } else {
        // 滑轮向下滚动
        this.smallChange();
      }
    },
    tapMap: function tapMap(e) {
      var xPage = navigator.appName == 'Netscape' ? e.pageX : event.x + document.body.scrollLeft;
      var yPage = navigator.appName == 'Netscape' ? e.pageY : event.y + document.body.scrollTop;
      console.log('xPage=' + xPage + ',yPage=' + yPage);
      var imgEl = document.getElementById("imageId");
      var img_x = this.locationLeft(imgEl);
      var img_y = this.locationTop(imgEl);
      console.log('img_x=' + img_x + ',img_y=' + img_y);
      var xPos = xPage - img_x;
      var yPos = yPage - img_y;
      console.log('xPos=' + xPos + ',yPos=' + yPos); // 当前点击位置

      var hotspot = {
        x: xPos,
        y: yPos
      }; //获取原样的比例x,y

      this.addAttress1(hotspot);
    },
    // 找到元素的屏幕位置
    locationLeft: function locationLeft(element) {
      var offsetTotal = element.offsetLeft;
      var scrollTotal = 0; // element.scrollLeft but we dont want to deal with scrolling - already in page coords

      if (element.tagName != "BODY") {
        if (element.offsetParent != null) return offsetTotal + scrollTotal + this.locationLeft(element.offsetParent);
      }

      return offsetTotal + scrollTotal;
    },
    // 找到元素的屏幕位置
    locationTop: function locationTop(element) {
      var offsetTotal = element.offsetTop;
      var scrollTotal = 0; // element.scrollTop but we dont want to deal with scrolling - already in page coords

      if (element.tagName != "BODY") {
        if (element.offsetParent != null) return offsetTotal + scrollTotal + this.locationTop(element.offsetParent);
      }

      return offsetTotal + scrollTotal;
    },

    /**
     * 添加位置
     */
    addAttress: function addAttress(hotspot) {
      this.valueList.splice(0);
      this.valueList.push(hotspot);
    },

    /**
     * 通过现在的比例获取原始的x,值
     */
    getsourcePix: function getsourcePix(hotspot) {
      this.x = hotspot.x * this.height / this.height1;
      this.y = hotspot.y * this.width / this.width1;
    },
    addAttress1: function addAttress1(hotspot) {
      this.valueList.splice(0); //y轴加上滚动条距离顶部的高度

      hotspot.y = hotspot.y + this.divTop + this.parentTop;
      hotspot.x = hotspot.x + this.divLeft;
      this.valueList.push(hotspot); //换算原比例图片

      this.getsourcePix(hotspot);
      this.$emit('getAxis', {
        x: this.x,
        y: this.y
      });
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.scrool, true);
  }
};